import useLocale from './useLocale';
import type { Category } from '@ilteducation/content-ref-data-types/models/data-types';

export default function getCategoryTranslation(category: Category) {
  const { t } = useLocale();
  const categoryCode = category.categoryCode;
  let translationKey = categoryCode;

  const deprecatedDoNotUse = categoryCode.charAt(0) === '_' ? categoryCode.substring(1) : undefined;

  if (category.kind && category.kind === 'grade') {
    translationKey = `grades.${categoryCode}`;
  }

  if (category.kind && category.kind === 'subject') {
    // In manabua we don't have the subjects in lokalise, so we always use the category name without translation
    return category.category;
  }

  const translation = t(translationKey);
  if (translation && translation !== categoryCode) {
    return translation;
  }

  if (deprecatedDoNotUse) {
    const deprecatedTranslation = t(deprecatedDoNotUse);

    if (deprecatedTranslation && deprecatedTranslation !== categoryCode) {
      return deprecatedTranslation;
    }
  }

  return categoryCode;
}
